import { render, staticRenderFns } from "./vip-random-test.vue?vue&type=template&id=89322b56&scoped=true&"
import script from "./vip-random-test.vue?vue&type=script&lang=js&"
export * from "./vip-random-test.vue?vue&type=script&lang=js&"
import style0 from "./vip-random-test.vue?vue&type=style&index=0&id=89322b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89322b56",
  null
  
)

export default component.exports